const API_BACKEND_URL = process.env.VUE_APP_API_BACKEND_URL || '/api/';

export default API_BACKEND_URL
